export default {
    getLogin(params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/app-login',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
	//帖子审核列表
	getBbsList (params) {
		return new Promise((resolve, reject) => {
			axios.get('/api/admin/bbs-cards',{
				params:params
			})
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
	//帖子审核
	BbsAudit(params) {
		return new Promise((resolve, reject) => {
			axios.post('/api/admin/bbs-audit',params)
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
	//帖子删除
	delBbs(id){
		return new Promise((resolve, reject) => {
			axios.delete('/api/admin/'+id+'/card-delete')
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
    //帖子评论列表
    getBbsComment(params) {
    	return new Promise((resolve, reject) => {
    		axios.get('/api/admin/bbs-comments',{
    			params:params
    		})
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
	//帖子评论审核额
	BbsCommentAudit(params) {
		return new Promise((resolve, reject) => {
			axios.post('/api/admin/bbs-comment-audit',params)
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
	//帖子评论删除
	delBbsComment(id){
		return new Promise((resolve, reject) => {
			axios.delete('/api/admin/'+id+'/bbs-comment-delete')
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
    //帖子评论留后审核
    adminAuditAfter(params){
       return new Promise((resolve, reject) => {
            axios.post('/api/admin/bbs-comment-delay-audit',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        }) 
   },
    //文章评论列表
    getArticleComment(params) {
    	return new Promise((resolve, reject) => {
    		axios.get('/api/admin/archive-comments',{
    			params:params
    		})
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
	//文章评论审核
	ArticleCommentAudit(params) {
		return new Promise((resolve, reject) => {
			axios.post('/api/admin/archive-comment-audit',params)
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
	//文章评论删除
	delArticleComment(id){
		return new Promise((resolve, reject) => {
			axios.delete('/api/admin/'+id+'/archive-comment-delete')
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
    //文章评论留后审核
    aArticleAuditAfter(params){
       return new Promise((resolve, reject) => {
            axios.post('/api/admin/archive-comment-delay-audit',params)
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        }) 
   },
	//搜索关键词
	getAdminsearch(params) {
		return new Promise((resolve, reject) => {
			axios.get('/api/data/search',{
				params:params
			})
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
    //热度
    getAdminhot(params) {
    	return new Promise((resolve, reject) => {
    		axios.get('/api/data/heat',{
    			params:params
    		})
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
    //关键词详情
    getSearchinfo(params) {
    	return new Promise((resolve, reject) => {
    		axios.get('/api/data/search-info',{
    			params:params
    		})
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
    //关键词列表
    getKeywordList(params) {
    	return new Promise((resolve, reject) => {
    		axios.get('/api/data/search-list')
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
    //论坛趋势
    getEchartsList(params) {
    	return new Promise((resolve, reject) => {
    		axios.get('/api/data/heat-chart',{
    			params:params
    		})
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
    //关键词趋势
    getKeyEchartsList(params) {
    	return new Promise((resolve, reject) => {
    		axios.get('/api/data/search-chart',{
    			params:params
    		})
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
    adminDownload(params){
    	return new Promise((resolve, reject) => {
    		axios.get('/api/data/excel',{
    			params:params
    		})
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
    // 2021-2  新接口
    getAdminhome(params){
    	return new Promise((resolve, reject) => {
    		axios.get('/api/data/index',{params:params})
    		.then((response) => {
    			resolve(response)
    		})
    	}, err => {
    		reject(err)
    	})
    },
    getMessage(){
        return new Promise((resolve, reject) => {
            axios.get('/api/data/warning-message-list')
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    readMessage(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/data/warning-message-read',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getAdminsearchnew(params){
        return new Promise((resolve, reject) => {
            axios.get('/api/data/new-search',{
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
    getAdminBbsinfo(params){
     return new Promise((resolve, reject) => {
        axios.get('/api/data/new-search-info',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
 },
 getAdminMessageinfo(params){
     return new Promise((resolve, reject) => {
        axios.get('/api/data/warning-message-info',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
 },
 getMoreBbs(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/data/bbs-type-more',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
getBbsMore(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/data/bbs-more',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
getUserBbsMore(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/data/bbs-user',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
getShow(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/data/bbs-info',{
            params:params
        })
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
getNewKeywordList(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/data/keyword-list',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
DelKeyword(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/data/keyword-del',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
editKey(params){
 return new Promise((resolve, reject) => {
    axios.get('/api/data/keyword-edit',{params:params})
    .then((response) => {
        resolve(response)
    })
}, err => {
    reject(err)
}) 
},
addKey(params){
 return new Promise((resolve, reject) => {
    axios.get('/api/data/keyword-add',{params:params})
    .then((response) => {
        resolve(response)
    })
}, err => {
    reject(err)
}) 
},
getBbsarr(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/data/bbs-arr',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    })
},
getCommentList(params){
    return new Promise((resolve, reject) => {
        axios.get('/api/data/comment-list',{params:params})
        .then((response) => {
            resolve(response)
        })
    }, err => {
        reject(err)
    }) 
}
}